import { AxiosInstance } from 'axios';
import { Email } from '../../types/widgets/email';

export const getRecentEmails = (count: number, instance: AxiosInstance): Promise<Email[]> => {
  return instance.get<Email[]>(`/recent-emails?count=${count}`).then(res => res.data);
};
